module.exports = __webpack_public_path__ + "media/images/button-azure-sso-bf2cff4d4d0d60f5deca66a033a66609.svg";